import { getApiErrorCode, getApiErrorMessage } from "../../../utils";

/* 서버 code → 화면 문구. 없는 code는 getApiErrorMessage로 넘긴다. */
const SIGN_UP_ERROR_MESSAGES: Record<string, string> = {
    PHONE_ALREADY_REGISTERED: "이미 가입된 휴대폰 번호입니다.",
    EMAIL_ALREADY_EXISTS: "이미 사용 중인 이메일입니다.",
    LICENSE_ID_ALREADY_USED: "이미 등록된 약사 면허 번호입니다.",
    HEALTHCARE_INSTITUTION_ALREADY_USED: "이미 등록된 요양기관 번호입니다.",
    ALREADY_PENDING_REVIEW: "이미 심사 중인 가입 신청이 있습니다.",
    SMS_SEND_FAILED: "인증번호 발송에 실패했습니다. 잠시 후 다시 시도해주세요.",
    RATE_LIMITED: "인증번호 요청이 너무 많습니다. 잠시 후 다시 시도해주세요.",
    AUTH_CODE_NOT_REQUESTED: "인증번호를 먼저 요청해주세요.",
    AUTH_CODE_MISMATCH: "인증번호가 일치하지 않습니다.",
    AUTH_CODE_EXPIRED: "인증번호가 만료되었습니다. 다시 전송해주세요.",
    AUTH_CODE_ATTEMPTS_EXCEEDED: "인증 시도 횟수를 초과했습니다. 인증번호를 다시 전송해주세요.",
    UPLOAD_URL_FAILED: "파일 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.",
    UNSUPPORTED_FILE_TYPE: "지원하지 않는 파일 형식입니다.",
    FILE_TOO_LARGE: "파일 용량이 너무 큽니다.",
    UPLOAD_FAILED: "파일 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.",
};

export const getSignUpErrorMessage = (error: unknown, fallback: string) => {
    const code = getApiErrorCode(error);
    if (code && SIGN_UP_ERROR_MESSAGES[code]) {
        return SIGN_UP_ERROR_MESSAGES[code];
    }
    return getApiErrorMessage(error, fallback);
};
